import {
    CREATE_ROLE,
    RETRIEVE_ROLES,
    UPDATE_ROLE
} from "../../actions/types";

const initialState = [];

function roleReducer(roles = initialState, action) {
    const {type, payload} = action;
    switch (type) {
        case CREATE_ROLE:
            return [...roles, payload];
        case RETRIEVE_ROLES:
            return payload;
        case UPDATE_ROLE:
            return roles.map((role) => {
                if (role.id === payload.id) {
                    return {...role, ...payload};
                } else {
                    return role;
                }

            })
        default:
            return roles;
    }
}

export default roleReducer;